import {
  collection,
  type CollectionReference,
  doc,
  type Firestore,
} from 'firebase/firestore'

// TODO: rename onboarding to beta_survey or something else like that
export const getSurveyConfigRef = (db: Firestore): ReturnType<typeof doc> =>
  doc(db, 'configuration', 'onboarding')

export const getSurveyConfigRevisionsRef = (
  db: Firestore
): CollectionReference => collection(getSurveyConfigRef(db), 'revisions')
